import * as z from 'zod';

export const localizedTextSchema = z
  .object({
    ru: z.string().nullish(),
    uz: z.string().nullish(),
    en: z.string().nullish(),
  })
  .loose();
export type LocalizedText = z.infer<typeof localizedTextSchema>;

export interface LocalizedTextInput {
  ru: string;
  uz?: string | undefined;
  en?: string | undefined;
}

export interface LocalizedTextPatch {
  ru?: string | null | undefined;
  uz?: string | null | undefined;
  en?: string | null | undefined;
}

const LOCALES = ['ru', 'uz', 'en'] as const;
export type BusinessLocale = (typeof LOCALES)[number];

export function normalizeLocale(language: string): BusinessLocale {
  return (LOCALES as readonly string[]).includes(language)
    ? (language as BusinessLocale)
    : 'ru';
}

function firstNonEmpty(...values: (string | null | undefined)[]): string {
  for (const value of values) {
    if (value !== null && value !== undefined && value !== '') return value;
  }
  return '';
}

export function displayLocalized(
  text: LocalizedText | null | undefined,
  locale: BusinessLocale,
  fallback = '',
): string {
  if (!text) return fallback;
  const picked = firstNonEmpty(
    text[locale],
    text.ru,
    text.uz,
    text.en,
    fallback === '' ? undefined : fallback,
  );
  return picked;
}

export function toLocalizedInput(
  ru: string,
  uz?: string,
  en?: string,
): LocalizedTextInput {
  const input: LocalizedTextInput = { ru: ru.trim() };
  const uzTrimmed = uz?.trim() ?? '';
  const enTrimmed = en?.trim() ?? '';
  if (uzTrimmed !== '') input.uz = uzTrimmed;
  if (enTrimmed !== '') input.en = enTrimmed;
  return input;
}
